module.exports = [{"title":"Useful Resources","items":[{"id":"challenges","title":"Challenges"}]}]